import { Button, Text } from '@mantine/core';
import { openConfirmModal } from '@mantine/modals';
import { useContext } from 'react';
import { ChatContext } from '../context/ChatContext';
import { useMantineTheme } from '@mantine/core';

const ResetChat = () => {
  const { resetChat, promtRef } = useContext(ChatContext)
  const theme = useMantineTheme();
  const isTet = theme.colorScheme === 'tet';
  const onConfirmReset = () => {
    openConfirmModal({
      zIndex: 9999,
      title: 'Reset Chat',
      centered: true,
      children: (
        <Text size="sm">
          All chat history will be deleted.
        </Text>
      ),
      labels: { confirm: 'Reset Chat', cancel: 'Cancel' },
      onCancel: () => {},
      onConfirm: resetChat,
    })
  }

  return (
    <>
      <Button
        variant="gradient"
        size="xs"
        style={{ marginRight: 8 }}
        onClick={onConfirmReset}
        
        gradient={
          isTet 
            ? { from: '#d32f2f', to: '#fbc02d', deg: 90 } 
            : { from: 'indigo', to: 'cyan' }
        }
        
      >
        Reset
      </Button>
    </>
  )
}

export default ResetChat
